(function () {
  'use strict';

  angular.module('app').component('providerCreditNoteDetail', providerCreditNoteDetail());

  function providerCreditNoteDetail() {
    return {
      bindings: {
        item: '<',
        mode: '<',
        showActionsFromModal: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
      },
      controller: ProviderCreditNoteDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/provider-credit-notes/provider-credit-note-detail/provider-credit-note-detail.component.html',
    };
  }

  ProviderCreditNoteDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'SessionService',
    'AbilityService',
    'moment',
    '$routeParams',
    'ProviderCreditNoteService',
    'BillService',
    'ProviderService',
    'TaxService',

    'DocumentTypeService',
    'MeasurementUnitService',

    // Angular downgraded service
    'companyService',
  ];

  function ProviderCreditNoteDetailComponent(
    config,
    UtilService,
    SessionService,
    AbilityService,
    moment,
    $routeParams,
    ProviderCreditNoteService,
    BillService,
    ProviderService,
    TaxService,

    DocumentTypeService,
    MeasurementUnitService,

    // Angular downgraded service
    companyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_providercreditnote_accountadmin'),
      canUpdate: AbilityService.can('update_providercreditnote_accountadmin'),
    };

    vm.dateDisplay = config.DATE_DISPLAY;

    vm.statusDraft = 'draft';
    vm.statusProcessed = 'processed';

    vm.creditNotFromBill = false;

    // private properties
    // -----------------------
    let company = SessionService.getSelectedAccountCompany();

    let userLanguageCode = SessionService.getUserLanguage().code;

    vm.$onInit = function () {
      if (vm.item.id) {
        // view - edit
        // if (!vm.item.user_id) {  // needed ?
        //     vm.item.user_id = SessionService.currentUser().id;
        // }

        vm.isElectronicDocument = vm.item.document_type.numbering_type === 'electronic';

        setItemOptions(vm.item, vm.mode);

        // vm.documentDate = moment(vm.item.date);
        vm.documentDate = vm.UtilService.startOfDayFormat(vm.item.date); // yyyy-mm-ddT06:00:00.000Z
      } else {
        // new
        vm.createMode = true;

        // vm.openBills = [];

        vm.item = {
          date: moment(),
          provider_credit_note_products: [],
          status: vm.statusDraft,
          apply_to_items: false,
          amount: 0,
          company_id: company.id,
          // user_id:               SessionService.currentUser().id
        };

        vm.sendProviderCreditNoteToProvider = false;

        // Initializers
        getDocumentTypes();

        vm.documentDate = moment();
      }

      // Initializers
      getCompany();
    };

    // public methods
    // -----------------------
    vm.downloadProviderCreditNotePdf = function () {
      ProviderCreditNoteService.downloadProviderCreditNotePDF(vm.item, userLanguageCode);
    };

    vm.openRelatedTransactions = function () {
      ProviderCreditNoteService.openRelatedTransactions(vm.item, vm.item.provider);
    };

    vm.isInvalidHeader = function () {
      if (vm.viewMode) return false;

      if (vm.sendingForm || !(vm.item.provider_id && vm.item.bill_id && vm.item.date)) {
        return true;
      }

      return false;
    };

    vm.selectDocumentType = function (documentType) {
      if (documentType.id === vm.lastDocumentTypeId) return;

      vm.documentType = documentType;
      vm.lastDocumentTypeId = documentType.id;

      setProviderCreditNoteDatePicker(vm.documentType);
    };

    vm.onProviderSelected = function (provider) {
      let selectProviderCallback = function () {
        vm.lastProviderId = provider.id;
        vm.item.provider_id = provider.id;
        vm.item.provider = provider;

        vm.item.bill_id = null;
        vm.lastBillId = null;

        getOpenBillsByProvider(provider.id);
      };

      // Delete credit note products for draft credit note if change provider, when the credit note has credit note products
      if (
        vm.item.status === vm.statusDraft &&
        vm.item.provider_credit_note_products.length > 0 &&
        provider.id !== vm.lastProviderId
      ) {
        let successCallback = function () {
          vm.item.provider_credit_note_products = [];

          selectProviderCallback();

          return;
        };

        let cancelCallback = function () {
          // Just to keep current provider
          vm.item.provider_id = vm.lastProviderId;
        };

        let modalParams = {
          title: 'CHANGE_PROVIDER_FOR_CURRENT_CREDIT_NOTE',
          body: 'CHANGE_PROVIDER_FOR_CURRENT_CREDIT_NOTE_WARNING',
        };

        vm.UtilService.warningMsg(modalParams, successCallback, cancelCallback);
      } else {
        // In case the user change the provider
        if (vm.lastProviderId && provider.id !== vm.lastProviderI) {
          vm.item.provider_credit_note_products = [];

          // vm.addProviderCreitNoteProduct();
        }

        selectProviderCallback();
      }
    };

    // When provider is empty
    vm.onProviderValidated = function (provider) {
      vm.item.provider = provider;

      if (!vm.item.provider && vm.item.provider_id) {
        resetProvider();
      }
    };

    vm.onProviderCleared = function (clearObj) {
      if (clearObj) {
        vm.item.provider = null;
      }

      resetProvider();
    };

    // ?
    vm.selectOpenBill = function (billId, totalBalance) {
      // Same open bill selected
      if (vm.lastBillId === billId) return;

      // vm.allProductsCabysCodeSet = true;

      vm.loadingProviderCreditNoteProducts = true;
      BillService.getBill(billId).then(function (bill) {
        vm.lastBillId = bill.id;

        vm.item.unit_cost_type = bill.unit_cost_type;

        vm.item.subtotal_services_taxable = bill.subtotal_services_taxable;
        vm.item.subtotal_services_exempt = bill.subtotal_services_exempt;
        vm.item.subtotal_services_exonerable = bill.subtotal_services_exonerable;
        vm.item.subtotal_goods_taxable = bill.subtotal_goods_taxable;
        vm.item.subtotal_goods_exempt = bill.subtotal_goods_exempt;
        vm.item.subtotal_goods_exonerable = bill.subtotal_goods_exonerable;

        vm.item.total_taxable = bill.total_taxable;
        vm.item.total_exempt = bill.total_exempt;
        vm.item.total_exonerable = bill.total_exonerable;
        vm.item.total_sale = bill.total_sale;
        vm.item.total_discount = bill.total_discount;
        vm.item.total_net_sale = bill.total_net_sale;

        vm.item.total_taxes = bill.total_taxes;
        vm.item.total_tax_exonerations = bill.total_tax_exonerations;
        vm.item.total_net_taxes = bill.total_net_taxes;
        vm.item.total_retornable_taxes = bill.total_retornable_taxes;
        vm.item.total_other_charges = bill.total_other_charges;
        vm.item.grand_total = bill.grand_total;
        vm.item.balance_due = totalBalance;

        // vm.item.user_id                      = bill.user_id || SessionService.currentUser().id; // needed ?
        // vm.item.credit_payment_days          = bill.credit_payment_days; // really ?

        vm.item.bill_id = bill.id;
        vm.item.currency_id = bill.currency_id;
        vm.item.currency = bill.currency;
        vm.item.provider_credit_note_products = [];

        vm.item.exchange_rate_value = bill.exchange_rate_value;
        vm.item.base_currency_symbol = bill.base_currency_symbo;

        bill.bill_products.forEach(function (billProduct) {
          let measurementUnit = vm.company.measurement_units.find(
            (item) => item.id === billProduct.measurement_unit_id
          );

          let providerCreditNoteProduct = {
            bill_product_id: billProduct.id, // what for ?
            product_id: billProduct.product_id,
            product_code: billProduct.product_code,
            product_cabys_code: billProduct.product_cabys_code,
            product_name: billProduct.product_name,
            product_type: billProduct.product_type,

            quantity: billProduct.quantity,
            unit_cost: billProduct.unit_cost,
            total_amount: billProduct.total_amount,
            discount_percentage: billProduct.discount_percentage,
            discount_amount: billProduct.discount_amount,
            subtotal_cost: billProduct.subtotal_cost,

            tax_percentage: billProduct.tax_percentage,
            tax_amount: billProduct.tax_amount,
            tax_exoneration_percentage: billProduct.tax_exoneration_percentage,
            tax_exoneration_amount: billProduct.tax_exoneration_amount,
            net_tax_percentage: billProduct.net_tax_percentage,
            net_tax_amount: billProduct.net_tax_amount,
            total_cost: billProduct.total_cost,

            remarks: billProduct.remarks,

            measurement_unit_id: billProduct.measurement_unit_id,
            measurement_unit_symbol: billProduct.measurement_unit_symbol,
            measurement_unit: measurementUnit,

            transaction_taxes: billProduct.transaction_taxes,

            product: billProduct.product,
          };

          /*if (vm.atvCrEnabled && vm.isElectronicDocument && !providerCreditNoteProduct.product_cabys_code) {
                        vm.allProductsCabysCodeSet = false;
                    }*/

          vm.item.provider_credit_note_products.push(providerCreditNoteProduct);
        });

        vm.item.total_products = angular.copy(vm.item.provider_credit_note_products);

        vm.loadingProviderCreditNoteProducts = false;

        // net_taxxx:                 billProduct.tax_amount,
        // taxable_base:            billProduct.taxable_base,
        // total_product:           billProduct.total_product,
      });
    };

    vm.openProviderInfoModal = function (provider) {
      ProviderService.openProviderInfoModal(provider);
    };

    vm.editProviderCreditNoteProductRemarks = function (creditNoteProduct) {
      vm.creditNoteProduct = creditNoteProduct;
    };

    // We better remove and update the bill
    vm.deleteProviderCreditNoteProduct = function (index) {
      vm.item.provider_credit_note_products.splice(index, 1);

      vm.item.total_products = angular.copy(vm.item.provider_credit_note_products);

      calculateProviderCreditNoteTotals();
    };

    // Apply to document or document items
    vm.applyCreditNoteTo = function () {
      if (vm.item.apply_to_items) {
        vm.item.amount = 0;
      }
    };

    // TODO: not implemented in the code and view
    vm.validateAmounts = function () {
      vm.errorAmountApplied = false;

      if (vm.item.amount > vm.item.balance_due) {
        vm.errorAmountApplied = true;
      }
    };

    vm.calculateProviderCreditNoteProductTotalCost = function (creditNoteProduct, index = 0) {
      creditNoteProduct.quantity = creditNoteProduct.quantity || 1;
      creditNoteProduct.tax_percentage = creditNoteProduct.tax_percentage || 0;

      if (creditNoteProduct.unit_cost > vm.item.total_products[index].unit_cost) {
        creditNoteProduct.unit_cost = vm.item.total_products[index].unit_cost;
      }

      let totalAmount = creditNoteProduct.quantity * creditNoteProduct.unit_cost;
      let discountAmount = totalAmount * (creditNoteProduct.discount_percentage / 100);
      let subtotalCost = totalAmount - discountAmount;

      let taxAmount = TaxService.getProductTaxesTotalAmount(creditNoteProduct.transaction_taxes);
      let taxExonerationAmount = TaxService.getProductTaxesTotalExonerationAmount(
        creditNoteProduct.transaction_taxes
      );
      let netTaxAmount = taxAmount - taxExonerationAmount;

      creditNoteProduct.total_amount = vm.UtilService.roundNum(totalAmount);
      creditNoteProduct.discount_amount = vm.UtilService.roundNum(discountAmount);
      creditNoteProduct.subtotal_cost = vm.UtilService.roundNum(subtotalCost);

      creditNoteProduct.tax_amount = vm.UtilService.roundNum(taxAmount);
      creditNoteProduct.tax_exoneration_amount = vm.UtilService.roundNum(taxExonerationAmount);
      creditNoteProduct.net_tax_amount = vm.UtilService.roundNum(netTaxAmount);

      creditNoteProduct.total_cost = vm.UtilService.roundNum(subtotalCost + netTaxAmount);

      calculateProviderCreditNoteTotals();

      // creditNoteProduct.total_cost = creditNoteProduct.total_cost || 0;
      // let taxAmount      = TaxService.setProductTotalTaxAmount(creditNoteProduct.transaction_taxes, subtotalCost);
      // creditNoteProduct.net_taxxx         = creditNoteProduct.tax_amount;
      // creditNoteProduct.total_product = creditNoteProduct.total_cost;
    };

    vm.editProviderCreditNote = function () {
      vm.editMode = true;
      vm.viewMode = false;

      getDocumentTypes();
      getOpenBillsByProvider(vm.item.provider.id);
    };

    /*vm.cancelEdit = function() {
            vm.item = vm.originalItem;

            setItemOptions(vm.item);
            setProviderCreditNoteProducts();
        };*/

    vm.saveProviderCreditNote = function (isFormValid, status) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();

        return;
      }

      // if (!vm.allProductsCabysCodeSet) return;

      let createCreditNote = function () {
        vm.item.status = status;

        let creditNote = setCreditNoteParams();

        // console.log(creditNote); return;

        vm.sendingForm = true;
        ProviderCreditNoteService.saveProviderCreditNote(creditNote).then(function (data) {
          let status = data.status;
          let response = data.response;

          if (status) {
            // success
            if (!vm.editMode) {
              // create
              vm.onSavedItem({ item: response });
            } else {
              setItemOptions(response);
            }
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.UtilService.scrollToTop();

          vm.sendingForm = false;
        });
      };

      if (status !== vm.statusDraft && vm.sendProviderCreditNoteToProvider) {
        let successCallBack = function (email) {
          vm.item.provider_email_receipt = email;

          createCreditNote();
        };

        ProviderCreditNoteService.openSendProviderCreditNoteToProvider(
          vm.item.provider.email,
          successCallBack
        );
      } else {
        vm.item.provider_email_receipt = vm.item.provider.email;

        createCreditNote();
      }
    };

    vm.cancel = function () {
      let successCallback = function () {
        /*if (vm.editMode) {
                    vm.cancelEdit();
                    return;
                }*/

        vm.onCanceledItem();
      };

      if (vm.createMode) {
        let cancelCallback = function () {
          return;
        };

        let modalParams = {
          body: 'WARNING_CANCEL_PROVIDER_CREDIT_NOTE',
        };

        vm.UtilService.warningMsg(modalParams, successCallback, cancelCallback);
      } else {
        successCallback();
      }
    };

    /*vm.convertAmountToBaseAccountingCurrency = function(amount) {
            if(!vm.item.exchange_rate_value){
                return 0;
            }
            return vm.UtilService.roundNum(amount * vm.item.exchange_rate_value);
        };*/

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      item.apply_to_items = item.apply_to_items;

      if (mode === 'edit') {
        vm.editProviderCreditNote();
      }

      vm.originalItem = angular.copy(item);

      vm.item.total_products = angular.copy(item.provider_credit_note_products);
    }

    // Initializers
    function getCompany() {
      vm.loadingCurrenciesPerCompany = true;

      vm.loadingCompany = true;
      companyService
        .getCompany(vm.item.company_id, {
          skip_check_role: true,
          lang: userLanguageCode,
        })
        .subscribe((response) => {
          vm.company = response;

          vm.companyBaseCurrencyId = vm.company.currency_id;
          vm.companyCurrencyIds = vm.company.currency_ids;

          if (vm.createMode) {
            if ($routeParams && $routeParams.billId) {
              vm.item.bill_id = $routeParams.billId;
              vm.item.bill = {
                bill_number: $routeParams.billNumber,
              };

              getProvider($routeParams.providerId);
              vm.selectOpenBill($routeParams.billId);

              vm.creditNotFromBill = true;
            }
          } else {
            // View / Edit
            if (vm.editMode) {
              vm.item.currency_id = vm.item.provider.currency_id
                ? vm.item.provider.currency_id
                : vm.companyBaseCurrencyId;
              vm.item.currency = vm.currenciesPerCompany.find(
                (x) => x.id === vm.item.provider.currency_id
              );
            }

            setProviderCreditNoteProducts();
          }

          vm.loadingCompany = false;
        });
    }

    function getDocumentTypes() {
      if (vm.documentTypes) return;

      let params = {
        get: 'active',
        transaction_type: 'provider_credit_notes',
        skip_check_role: true,
      };

      vm.loadingDocumentTypes = true;
      DocumentTypeService.getDocumentTypes(params).then(function (data) {
        vm.documentTypes = data.items;

        // Preload default document type on create
        if (vm.createMode) {
          vm.documentType = vm.documentTypes.find((documentType) => documentType.is_default);
          vm.item.document_type_id = vm.documentType.id;
        } else {
          vm.documentType = vm.documentTypes.find((x) => x.id === vm.item.document_type_id);
        }

        vm.lastDocumentTypeId = vm.documentType.id;

        vm.isElectronicDocument = vm.documentType.numbering_type === 'electronic';

        setProviderCreditNoteDatePicker(vm.documentType);

        vm.loadingDocumentTypes = false;
      });
    }

    function resetProvider() {
      vm.item.provider_id = null;
      vm.item.currency_id = null;
      vm.item.due_date = null;

      // vm.item.credit_payment_days = null; // really ?

      /*if (vm.item.payment_method_code){
                vm.item.payment_method_code = null;
            }*/

      vm.item.provider_credit_note_products = []; // check
    }

    function calculateProviderCreditNoteTotals() {
      let subtotal_services_taxable = 0;
      let subtotal_services_exempt = 0;
      let subtotal_services_exonerable = 0;
      let subtotal_goods_taxable = 0;
      let subtotal_goods_exempt = 0;
      let subtotal_goods_exonerable = 0;

      let total_sale = 0;
      let total_discount = 0;
      let total_net_sale = 0;
      let total_taxes = 0;
      let total_tax_exonerations = 0;
      let total_net_taxes = 0;
      let grand_total = 0;

      vm.item.provider_credit_note_products.forEach(function (credit_note_product) {
        let total_amount = credit_note_product.total_amount;

        if (!credit_note_product.is_exempt) {
          if (
            credit_note_product.measurement_unit &&
            credit_note_product.measurement_unit.is_a_service
          ) {
            if (credit_note_product.tax_exoneration_amount > 0) {
              subtotal_services_taxable +=
                (1 -
                  (credit_note_product.tax_exoneration_percentage * 1) /
                    credit_note_product.tax_percentage) *
                total_amount;
              subtotal_services_exonerable += total_amount - subtotal_services_taxable;
            } else {
              subtotal_services_taxable += total_amount;
            }
          } else {
            if (credit_note_product.tax_exoneration_amount > 0) {
              subtotal_goods_taxable +=
                (1 -
                  (credit_note_product.tax_exoneration_percentage * 1) /
                    credit_note_product.tax_percentage) *
                total_amount;
              subtotal_goods_exonerable += total_amount - subtotal_goods_taxable;
            } else {
              subtotal_goods_taxable += total_amount;
            }
          }
        } else {
          if (
            credit_note_product.measurement_unit &&
            credit_note_product.measurement_unit.is_a_service
          ) {
            subtotal_services_exempt += total_amount;
          } else {
            subtotal_goods_exempt += total_amount;
          }
        }

        total_sale += credit_note_product.total_amount;
        total_discount += credit_note_product.discount_amount;
        total_net_sale += credit_note_product.subtotal_cost;
        total_taxes += credit_note_product.tax_amount;
        total_tax_exonerations += credit_note_product.tax_exoneration_amount;
        total_net_taxes += credit_note_product.net_tax_amount;
        grand_total += credit_note_product.total_cost;
      });

      let total_taxable = subtotal_services_taxable + subtotal_goods_taxable;
      let total_exempt = subtotal_services_exempt + subtotal_goods_exempt;
      let total_exonerable = subtotal_services_exonerable + subtotal_goods_exonerable;
      let total_retornable_taxes = 0;
      let total_other_charges = 0;

      vm.item.subtotal_services_taxable = vm.UtilService.roundNum(subtotal_services_taxable);
      vm.item.subtotal_services_exempt = vm.UtilService.roundNum(subtotal_services_exempt);
      vm.item.subtotal_services_exonerable = vm.UtilService.roundNum(subtotal_services_exonerable);
      vm.item.subtotal_goods_taxable = vm.UtilService.roundNum(subtotal_goods_taxable);
      vm.item.subtotal_goods_exempt = vm.UtilService.roundNum(subtotal_goods_exempt);
      vm.item.subtotal_goods_exonerable = vm.UtilService.roundNum(subtotal_goods_exonerable);

      vm.item.total_taxable = vm.UtilService.roundNum(total_taxable);
      vm.item.total_exempt = vm.UtilService.roundNum(total_exempt);
      vm.item.total_exonerable = vm.UtilService.roundNum(total_exonerable);
      vm.item.total_sale = vm.UtilService.roundNum(total_sale);
      vm.item.total_discount = vm.UtilService.roundNum(total_discount);
      vm.item.total_net_sale = vm.UtilService.roundNum(total_net_sale);

      vm.item.total_taxes = vm.UtilService.roundNum(total_taxes);
      vm.item.total_tax_exonerations = vm.UtilService.roundNum(total_tax_exonerations);
      vm.item.total_net_taxes = vm.UtilService.roundNum(total_net_taxes);
      vm.item.total_retornable_taxes = vm.UtilService.roundNum(total_retornable_taxes);
      vm.item.total_other_charges = vm.UtilService.roundNum(total_other_charges);
      vm.item.grand_total = vm.UtilService.roundNum(grand_total);
    }

    function setCreditNoteParams() {
      let creditNote = angular.copy(vm.item);

      delete creditNote.currency;
      delete creditNote.provider;
      // delete creditNote.credit_payment_days; // really ? // really ?

      creditNote.provider_credit_note_products.forEach(function (product) {
        delete product.$$hashKey;
        delete product.measurement_unit;
        delete product.product;
      });

      return creditNote;
    }

    function getProvider(providerId) {
      ProviderService.getProvider(providerId, { skip_check_role: true }).then(function (data) {
        vm.item.provider_id = data.id;
        vm.item.provider = data;
      });
    }

    function getOpenBillsByProvider(providerId) {
      let params = {
        get: 'open_bills', // paid / accepted
        provider_id: providerId,
        // atvCrEnabled:      vm.atvCrEnabled,
        by_reference_date: vm.item.date,
        skip_check_role: true,
      };

      vm.loadingOpenBills = true;
      BillService.getBills(params).then(function (data) {
        vm.openBills = data.items;

        vm.loadingOpenBills = false;

        // Why ?
        if (vm.item.bill_id) {
          let bill = vm.openBills.find((x) => x.id === vm.item.bill_id);

          if (bill) {
            vm.selectOpenBill(bill.id, vm.item.balance_due);
          }
        }
      });
    }

    function setProviderCreditNoteProducts() {
      vm.loadingProviderCreditNoteProducts = false;

      if (vm.item.provider_credit_note_products.length === 0) return;

      // vm.allProductsCabysCodeSet = true;

      vm.item.provider_credit_note_products.forEach(function (creditNoteProduct) {
        let measurementUnits = MeasurementUnitService.setMeasurementUnitsByProductType(
          vm.company.measurement_units,
          creditNoteProduct.product_type
        );

        let measurementUnit = measurementUnits.find(
          (item) => item.id === creditNoteProduct.measurement_unit_id
        );

        selectMeasurementUnit(creditNoteProduct, measurementUnit);

        /*if (vm.atvCrEnabled && vm.isElectronicDocument && !creditNoteProduct.product_cabys_code) {
                    vm.allProductsCabysCodeSet = false;
                }*/

        // If product is related to booking item - what for ?
        if (creditNoteProduct.booking_item_id) {
          creditNoteProduct.booking_item_unit_cost = creditNoteProduct.unit_cost;
          creditNoteProduct.booking_item_total_cost = creditNoteProduct.total_cost;
        }
      });
    }

    function selectMeasurementUnit(creditNoteProduct, measurementUnit) {
      creditNoteProduct.measurement_unit = measurementUnit;
      creditNoteProduct.measurement_unit_symbol = measurementUnit.symbol;
    }

    function setProviderCreditNoteDatePicker(documentType) {
      let minDate = documentType.allows_past_days ? false : moment();
      let maxDate = documentType.allows_future_days ? false : moment();

      let onChangeDate = () => {
        getOpenBillsByProvider(vm.item.provider_id);
      };

      vm.datePickerOptions = vm.UtilService.singleDatePickerOptions({
        minDate: minDate,
        maxDate: maxDate,
        dateDisplay: vm.dateDisplay,
        onChangeDate: onChangeDate,
      });
    }
  }
})();
